import api from "./api/api";

const ALERT_AUDIT_LOG_API = '/api/alert-audit-log';

// Get audit history for a specific alert report
export const getAlertAuditHistory = async (alertReportId, page = 1, limit = 50, customAlertSlug = null) => {
    try {
        const params = { page, limit };

        if (customAlertSlug) {
            params.customAlertSlug = customAlertSlug;
        }
        const response = await api.get(`${ALERT_AUDIT_LOG_API}/${alertReportId}/history`, {
            params
        });
        return response;
    } catch (error) {
        console.error('Error getting alert audit history:', error);
        throw error;
    }
};

// Get audit summary for a specific alert report
export const getAlertAuditSummary = async (alertReportId, customAlertSlug = null) => {
    try {
        const params = {};
        if (customAlertSlug) {
            params.customAlertSlug = customAlertSlug;
        }
        
        const response = await api.get(`${ALERT_AUDIT_LOG_API}/${alertReportId}/summary`, {
            params
        });
        return response;
    } catch (error) {
        console.error('Error getting alert audit summary:', error);
        throw error;
    }
}; 